import HistoryDataList from "./components/HistoryDataList";
import React, { useCallback, useRef } from "react";
import { DatePicker, Dialog, Toast } from "antd-mobile-v5";
import { useHistory } from "react-router-dom";
import { divide } from "lodash";
import { DeleteOutline } from "antd-mobile-icons";
import instance from "../../../../util/axios";

export default function CompletionList() {
  const history = useHistory();
  const datagridRef = useRef<any>(null);
  return (
    <>
      <HistoryDataList
        url={`/erp/sku/workshop/getCompletionFillingList`}
        sorter={{ field: "createTime", order: "descend" }}
        descriptions={[
          {
            fieldName: "workshopId",
            fieldShowName: "车间",
            width: 100,
            inputType: 6,
            dictionary: "erp_workshop",
            render: (item: any) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>{item.workshopId}</span>
                  {item.status === "已保存" && (
                    <DeleteOutline
                      onClick={(e) => {
                        e.stopPropagation();
                        Dialog.confirm({
                          content: "确定要删除吗？",
                          onConfirm: () => {
                            instance
                              .get(
                                `/erp/sku/workshop/deleteCompletionFilling?fillingId=${item.fillingId}`
                              )
                              .then((resp) => {
                                if (resp.data.Status === "1") {
                                  Toast.show({
                                    icon: "success",
                                    content: "删除成功",
                                  });
                                  datagridRef.current?.refresh();
                                }
                              });
                          },
                        });
                      }}
                    />
                  )}
                </div>
              );
            },
          },
          {
            fieldName: "procedureId",
            fieldShowName: "工序",
            width: 100,
            inputType: 6,
            dictionary: "erp_procedure",
          },
          {
            fieldName: "orderCalType",
            fieldShowName: "类型",
            width: 100,
            inputType: 6,
            dictionary: "dict_order_production_cal_type",
          },
          {
            fieldName: "staffId",
            fieldShowName: "员工",
            width: 100,
            inputType: 6,
            dictionary: "base_staff",
          },

          {
            fieldName: "createTime",
            fieldShowName: "填报日期",
            width: 120,
          },
          {
            fieldName: "status",
            fieldShowName: "状态",
            width: 120,
          },
        ]}
        ref={datagridRef}
        onClickRow={(info) => {
          history.push(`/erp/completion/historyNew/detail/${info?.fillingId}`);
        }}
      />
    </>
  );
}
